import { Countries } from '@xbs/xbs-enums';

export class MethodEvaluationConstants {
  public static readonly BY_JURISDICTION = {
    [Countries.ByIso.USA.IsoCode]: {
      'Services': {
        'CUT/CUP': 'CUP', // This is a temporary fix, refer TPIQ-2626
        'Resale Price Method': 'Resale Price Method', // This is a temporary fix, refer TPIQ-2626
        'Comparable Uncontrolled Services Price Method': 'CUSP',
        'Gross Services Margin Method': 'GSMM',
        'Cost Plus Method': 'Cost of Services Plus Method',
        'CP': 'Cost of Services Plus Method',
        'TNMM/CPM': 'CPM',
        'Profit Split Method': 'Profit Split Method',
        'Services Cost Method': 'Services Cost Method'
      },
      'Tangible Goods': {
        'CUT/CUP': 'CUP',
        'Resale Price Method': 'Resale Price Method',
        'RSP': 'Resale Price Method',
        'Cost Plus Method': 'Cost Plus Method',
        'CP': 'Cost Plus Method',
        'TNMM/CPM': 'CPM',
        'Profit Split Method': 'Profit Split Method',
      },
      'Intangible Goods': {
        'CUT/CUP': 'CUT',
        'TNMM/CPM': 'CPM',
        'Profit Split Method': 'Profit Split Method',
      },
      'Loans': {
        'CUT/CUP': 'CUP',
        'TNMM/CPM': 'CPM',
        'Profit Split Method': 'Profit Split Method',
      }
    },
    [Countries.ByIso.TWN.IsoCode]: {
      'Services': {
        'CUT/CUP': 'CUP',
        'Cost Plus Method': 'Cost Plus Method',
        'CP': 'Cost Plus Method',
        'TNMM/CPM': 'CPM',
        'Profit Split Method': 'Profit Split Method',
        'Other': 'Other'
      },
      'Tangible Goods': {
        'CUT/CUP': 'CUP',
        'Resale Price Method': 'Resale Price Method',
        'RSP': 'Resale Price Method',
        'Cost Plus Method': 'Cost Plus Method',
        'CP': 'Cost Plus Method',
        'TNMM/CPM': 'CPM',
        'Profit Split Method': 'Profit Split Method',
        'Other': 'Other'
      },
      'Intangible Goods': {
        'CUT/CUP': 'CUP',
        'TNMM/CPM': 'CPM',
        'Profit Split Method': 'Profit Split Method',
        'Other': 'Other'
      },
      'Loans': {
        'CUT/CUP': 'CUP',
        'TNMM/CPM': 'CPM',
        'Profit Split Method': 'Profit Split Method',
        'Other': 'Other'
      }
    },
    'OtherJurisdictions': {
      'Services': {
        'CUT/CUP': 'CUP',
        'Cost Plus Method': 'Cost Plus Method',
        'CP': 'Cost Plus Method',
        'TNMM/CPM': 'TNMM',
        'Profit Split Method': 'Profit Split Method',
        'Other': 'Other'
      },
      'Tangible Goods': {
        'CUT/CUP': 'CUP',
        'Resale Price Method': 'Resale Price Method',
        'RSP': 'Resale Price Method',
        'Cost Plus Method': 'Cost Plus Method',
        'CP': 'Cost Plus Method',
        'TNMM/CPM': 'TNMM',
        'Profit Split Method': 'Profit Split Method',
        'Other': 'Other'
      },
      'Intangible Goods': {
        'CUT/CUP': 'CUP',
        'TNMM/CPM': 'TNMM',
        'Profit Split Method': 'Profit Split Method',
        'Other': 'Other'
      },
      'Loans': {
        'CUT/CUP': 'CUP',
        'TNMM/CPM': 'TNMM',
        'Profit Split Method': 'Profit Split Method',
        'Other': 'Other'
      }
    }
  };

  public static readonly DB_TO_DISPLAY_NAME = {
    'Comparable Uncontrolled Services Price Method': 'CUSP',
    'Gross Services Margin Method': 'GSMM'
  };
}
